import React, { useMemo } from 'react'
import Table from 'rc-table'
import classNames from 'classnames'
import { cloneDeep } from 'lodash'
import Icon from 'meinian-package/src/component/icon'
import { BatchItem } from '../batch'
import './index.less'

const SORT_VALUE = { DESCEND: 'descend', ASCEND: 'ascend' }

export default (props) => {
  const { className, onSort, data, columns, sortValue, isBatch, keyValue, onSelectBatch, sticky, ...otherProps } = props

  const mergedColumns = useMemo(() => {
    const result = columns.map((_column) => {
      const column = cloneDeep(_column)
      if (column.sorter === true) {
        column.title = <span>
          {column.title}
          <div
            onClick={() => onSort?.({
              key: column.key,
              sort: sortValue.key !== column.key || !sortValue.sort ? SORT_VALUE.DESCEND
                : sortValue.sort === SORT_VALUE.DESCEND ? SORT_VALUE.ASCEND : undefined
            })}
            className="sort-icon-wrap"
          >
            <Icon type="m-paixu_shang" className={classNames('sort-icon', { active: (sortValue.sort && sortValue.key === column.key && sortValue.sort === SORT_VALUE.ASCEND) })} />
            <Icon type="m-paixu_xia" className={classNames('sort-icon', { active: sortValue.sort && sortValue.key === column.key && sortValue.sort === SORT_VALUE.DESCEND })} />
          </div>
        </span>
        column.className = column.className || ''
        column.className += ' sort'
      }
      return column
    })
    if (isBatch) {
      result.unshift({
        title: '',
        dataIndex: '',
        key: 'batch',
        width: 40,
        className: 'batch',
        render: row => <BatchItem className="table" keyValue={row[keyValue]} onChange={(_keyValue, e) => onSelectBatch?.(_keyValue, e, row)} info={row} />
      })
    }
    return result
  }, [columns, sortValue, isBatch])

  return <Table
    className={classNames('meinian-table', className)}
    columns={mergedColumns}
    scroll={{ x: true, y: null }}
    data={data}
    sticky={sticky}
    {...otherProps}
  />
}
